import { ShieldCheck, Users, Clock, Percent } from 'lucide-react';

const ValidationMetrics = () => {
  const metrics = [
    {
      id: 1,
      value: "500+",
      label: "Active Kitchens Deployed",
      description: "Powering independent bistros, fast-casual chains, and high-scale multi-branch creameries globally.",
      icon: <Users className="w-5 h-5 text-blue-400" />
    },
    {
      id: 2,
      value: "30%",
      label: "Average Waste Reduction",
      description: "Smart ingredient monitoring stops inventory leakage, over-portioning, and raw material spoilage.",
      icon: <Percent className="w-5 h-5 text-cyan-400" />
    },
    {
      id: 3,
      value: "99.9%",
      label: "System Order Uptime",
      description: "Our cloud backbone guarantees your point-of-sale and kitchen screens stay live during busy weekend rushes.",
      icon: <ShieldCheck className="w-5 h-5 text-blue-500" />
    },
    {
      id: 4,
      value: "15 Min",
      label: "Average Manager Setup",
      description: "Clean, intuitive layouts mean your location managers and floor staff require zero technical training to begin.",
      icon: <Clock className="w-5 h-5 text-cyan-500" />
    }
  ];

  return (
    <section className="py-20 bg-zinc-950 text-white relative border-t border-zinc-900" id="metrics">
      <div className="w-full px-6 sm:px-12 lg:px-16 mx-auto">
        
        {/* --- GRID ARCHITECTURE --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((item) => (
            <div 
              key={item.id} 
              className="bg-zinc-900/50 border border-zinc-800/80 rounded-2xl p-6 flex flex-col justify-between transition-all duration-300 hover:border-zinc-700 hover:bg-zinc-900"
            >
              <div className="space-y-4">
                {/* Icon Container */}
                <div className="w-10 h-10 bg-zinc-950 border border-zinc-800 rounded-xl flex items-center justify-center">
                  {item.icon}
                </div>
                
                {/* Numeric Display */}
                <div className="space-y-1">
                  <p className="text-3xl sm:text-4xl font-black text-white font-mono tracking-tight">
                    {item.value}
                  </p>
                  <p className="text-sm font-bold text-zinc-200 tracking-wide">
                    {item.label}
                  </p>
                </div>
              </div>

              {/* Description Context */}
              <p className="text-zinc-400 text-xs sm:text-sm leading-relaxed mt-4 pt-4 border-t border-zinc-800/60 font-medium">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* --- FOOTNOTE SUBTEXT --- */}
        <div className="mt-12 text-center">
          <p className="text-xs text-zinc-500 font-mono">
            Data aggregated across verified outlets using getsoko.app ecosystem. Powered by Top Orion.
          </p>
        </div>

      </div>
    </section>
  );
};

export default ValidationMetrics;